module.exports = __webpack_public_path__ + "static/media/AS Xpert logo web.fb348d40.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/AS Xpert logo web.png
// module id = 1361
// module chunks = 0